import { makeStyles } from '@lifeomic/chroma-react/styles/makeStyles';
import { alpha } from '@mui/material/styles';
import { ViewMode } from '../AITools/Attachments/InlineAttachment';

export const useSharedStyles = makeStyles<{ viewMode: ViewMode }>(theme => ({
  presentationHeader: {
    animation: ({ viewMode }) =>
      viewMode === 'print' ? 'none' : '$fadeIn 0.25s ease-out backwards',
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    borderRadius: theme.pxToRem(10),
    padding: theme.spacing(2, 2, 2, 2.5),
    '@media print': {
      '&': {
        breakInside: 'avoid',
        breakAfter: 'avoid',
      },
    },
  },
  impressionIconRoot: {
    color: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? alpha(theme.palette.common.white, 0.8)
        : theme.palette.blue[900],
    border: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? `2px solid ${theme.palette.primary.main}`
        : undefined,
    backgroundColor: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? 'rgba(0, 0, 0, 0.9)'
        : theme.palette.darkGraphite[50],
    maxHeight: theme.pxToRem(42),
    maxWidth: theme.pxToRem(42),
    minHeight: theme.pxToRem(42),
    minWidth: theme.pxToRem(42),
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? alpha(theme.palette.common.white, 0.9)
        : theme.palette.text.primary,
    marginBottom: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? 0
        : theme.spacing(0.75),
    fontWeight: ({ viewMode }) =>
      viewMode === 'presentation-expanded' ||
      viewMode === 'presentation-compact' ||
      viewMode === 'print'
        ? 'normal'
        : theme.typography.fontWeightBold,
    lineHeight: 1.35,
    maxWidth: '55ch',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
}));
